import React, {useEffect, useState} from 'react';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import {useSelector} from 'react-redux';

import UserIcon from 'src/HeaderComponents/UserIcon';
import FoxShopIcon from 'src/HeaderComponents/FoxShopIcon';
import {MainIcon} from 'src/HeaderComponents/HeaderComponents';
import CopilottedView from 'src/Modules/CommonView/CopilottedView';
import {PageTitle} from 'src/HeaderComponents/HeaderComponents';
import {SafeAreaView} from 'react-native-safe-area-context';
import CommunityPage from 'src/LandingPage/CommunityPage';
import DrawerTab from 'src/Nav/DrawerTab';
////// Explorer pass
import ExplorerPassLanding from 'src/ExplorerPass/ExplorerPassLanding';
import HomeLandingTab from '../LandingPage/Home/HomeLandingTab';
import JoinLanding from 'src/JoinRedeem/JoinLandingPage';
import LocalTab from 'src/Local/LocalTab';
import {CopilotProvider, useCopilot} from 'react-native-copilot';

import {dispatchAction} from '../Utils/helpers';
import {setHasSeenTurtorial} from '../Redux/reducers/current_screen.reducer';
import {mmkvStorage} from '../Utils/mmkvStorage';
import {Platform} from 'react-native';

const Tab = createBottomTabNavigator();

const LandingPageTabs = () => {
  const {copilotEvents, start} = useCopilot();
  console.log('LandingPageTabs Rerender', {start});

  const playTestState = useSelector((state) => state.app_info?.playTestState);
  const delayedDeepLink = useSelector(
    (state) => state.current_screen?.delayedDeepLink,
  );
  const isOnLoadingScreens = useSelector((state) =>
    [
      'AppIntroSwiper',
      'LoginPage',
      'LoginAdditionalInfoFullScreenPage',
      'AppLoadingPage',
    ]?.includes(state.current_screen?.currentScreen),
  );

  const [copilotPressed, setCopilotPressed] = useState(0);

  // here because updates were affecting
  useEffect(() => {
    const hasViewedTutorial = mmkvStorage.getString('hasViewedTutorial');

    if (playTestState) {
      return;
    }

    if (delayedDeepLink) {
      return console.log('will open deep link first');
    }

    if (isOnLoadingScreens) {
      return console.log('copiolot: not on loading page');
    }

    if (hasViewedTutorial) {
      return console.log('already has seen copoliot');
    }

    if (!copilotPressed) {
      setCopilotPressed(1);
      if (Platform.OS != 'web') {
        setTimeout(() => {
          console.log('starting copilot');
          start?.();
        }, 500);
      }
    }
  }, [isOnLoadingScreens, delayedDeepLink]);

  useEffect(() => {
    copilotEvents.on('stop', () => {
      // Copilot tutorial finished!
      console.log('setHasSeenTurtorial1');
      mmkvStorage.set('hasViewedTutorial', 'true');
      dispatchAction(setHasSeenTurtorial(1));
    });
    return () => {
      console.log('turning off copilot events');
      copilotEvents.off('stop');
    };
  }, []);
  return (
    <SafeAreaView
      style={{flex: 1, backgroundColor: 'white', marginBottom: -15}}>
      <Tab.Navigator
        tabBar={(props = {}) => <DrawerTab {...props} />}
        screenOptions={() => ({
          title: 'Home',
          headerHideShadow: true,
          unmountOnBlur: true,
          headerTitleAlign: 'center',
          headerTitleStyle: {
            justifyContent: 'center',
            backgroundColor: 'red',
          },
          headerStyle: {
            elevation: 0,
            shadowOpacity: 0,

            boxShadow: '',
            shadowColor: 'transparent',
          },
          headerLeft: () => (
            <CopilottedView
              text="This part’s all about YOU. Access your profile, badges, support, and FAQs here. Happy hunting!"
              order={7}
              name="user"
              style={{
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
              }}>
              <UserIcon />
            </CopilottedView>
          ),
          headerTitle: () => <HeaderTitle />,
          headerRight: () => (
            <CopilottedView
              text="This is the Fox Shop! It’s your one-stop-shop for tickets and redeeming 3rd party vouchers."
              order={2}
              name="fox_shop"
              style={{
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
              }}>
              <FoxShopIcon />
            </CopilottedView>
          ),
        })}>
        <Tab.Screen name="LandingPage" component={HomeLandingTab} />
        <Tab.Screen name="LocalTab" component={LocalTab} />
        <Tab.Screen name="ExplorerPass" component={ExplorerPassLanding} />
        <Tab.Screen name="Community" component={CommunityPage} />
        <Tab.Screen name="JoinLanding" component={JoinLanding} />
      </Tab.Navigator>
    </SafeAreaView>
  );
};

const HeaderTitle = () => {
  const headerTitle = useSelector((state) => {
    const currentScreen = state.current_screen?.currentScreen;
    if (currentScreen === 'LandingPage' || currentScreen == 'MapLandingPage') {
      return 'Landing Page';
    } else if (currentScreen == 'Community') {
      return 'Daily Challenges';
    } else if (currentScreen == 'Passport') {
      return 'Dining Deals';
    } else if (currentScreen == 'Events') {
      return 'Custom Events';
    } else if (currentScreen == 'JoinLanding') {
      return 'Join/Redeem';
    } else if (currentScreen?.toLowerCase?.()?.includes('local')) {
      return `Let's Roam Local`;
    } else {
      return 'Landing Page';
    }
  });

  console.log('the app title screen is', {headerTitle});
  if (headerTitle == 'Landing Page') {
    return (
      <CopilottedView
        text="Welcome to Let's Roam, your global exploration destination! Let’s walk through how to use our app."
        order={1}
        name="Let's Roam"
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
        }}>
        <MainIcon />
      </CopilottedView>
    );
  } else {
    return <PageTitle text={headerTitle} />;
  }
};

const CopilotedLandingPageTabs = () => {
  return (
    <CopilotProvider
      overlay="view"
      labels={{
        skip: 'Skip Intro',
        previous: 'Previous',
        next: 'Next',
        finish: 'Finish',
      }}>
      <LandingPageTabs />
    </CopilotProvider>
  );
};

export default CopilotedLandingPageTabs;

// export default CopilotedLandingPageTabs
// export default copilot({
//   stepNumber: '#E87722',

//   stepNumberText: 'black',

// / or 'view'
//   // animated: true, // or false
// })(LandingPageTabs);
